<template>
  <div class="mpf-grid-row">
    <div class="mpf-grid-column-full">
      <MpfForm
        :fields="formAppointmentReason.fields"
        submit-label="Continue"
        @submit="handleSubmit"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useRouter } from 'vue-router';

  import MpfForm from '../components/MpfForm/MpfForm.vue';
  import { formAppointmentReason } from '../../data/forms';
  import { useAppointmentBookingStore } from '../../stores/useAppointmentBookingStore';
  import { useBookingLinkRoute } from '../composables/useBookingLinkRoute';

  const router = useRouter();
  const store = useAppointmentBookingStore();
  const { bookingLinkId, pathForStep } = useBookingLinkRoute();

  // Direct entry resolves the link rather than bouncing — a patient who lands
  // here from a bookmark gets the step, not a redirect.
  onMounted(async () => {
    if (bookingLinkId.value && !store.linkType) await store.loadLink(bookingLinkId.value);
  });

  const handleSubmit = async (data: { valid: boolean; values: Record<string, any> }) => {
    if (!data.valid) return;

    store.setReasonForAppointment(data.values.reasonForAppointment ?? null);

    const next = store.nextStep('appointment-booking-reason-for-appointment');
    if (!next) return;

    await router.push(pathForStep(next));
  };
</script>
